<template>
  <div class="uploaded-products bg-white px-4 pt-4 pb-4">
    <h2 class="text-gray-500 text-sm">Total Uploaded products</h2>
    <GChart
      type="AreaChart"
      :data="chartData"
      :options="chartOptions"
    />
    <div class="mt-4">
      <p class="text-gray-400 leading-none">Total Items</p>
      <span class="text-3xl">{{numberFormat(total, '0,0')}}</span>
      <span class="float-right"><i class="el-icon-caret-top text-lg text-green-500"></i></span>
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  name: 'total_uploaded_products',
  data() {
    return {
      chartOptions: {
        hAxis: { textPosition: 'none' },
        chartArea: { left: '0%', width: '100%', height: '100%' },
        vAxis: {
          baselineColor: 'none',
          textPosition: 'none',
          gridlines: {
            color: 'none',
          },
        },
        colors: ['#D58ED4'],
        bar: { groupWidth: '20%' },
      },
    };
  },
  computed: {
    chartData() {
      return this.$store.getters['Dashboard/fetchUploadedProductsStats'];
    },

    total() {
      return this.$store.getters['Dashboard/totalUploadedProducts'];
    },
  },
  components: {
    GChart,
  },
  methods: {},

  async mounted() {
    await this.$store.dispatch('Dashboard/fetchUploadedProducts');
  },
};
</script>

<style scoped lang="scss">
.uploaded-products {
  flex: 0 1 49%;
}
</style>
